/* tslint:disable */
/* eslint-disable */
/**
 * Marsinet API
 * Esta API es utilizada tanto por Marsinet como por MarsiConnect. Proporciona todos los endpoints actualizados y documentación detallada, incluyendo ejemplos de datos y mocks de prueba para verificar el comportamiento de cada llamada.
 *
 * OpenAPI spec version: 5.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import globalAxios, {
  AxiosResponse,
  AxiosInstance,
  AxiosRequestConfig,
} from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  RequestArgs,
  BaseAPI,
  RequiredError,
} from '../base';
import { CreateSurveyDto } from '../models';
import { SubscribeOrgsBody } from '../models';
import { SubscribeOrgsBody1 } from '../models';
import { SubscribeUsersBody } from '../models';
import { SurveyContentDto } from '../models';
import { SurveyCreationDraftDto } from '../models';
import { SurveyCreationDraftTableDto } from '../models';
import { SurveyPendingTableDto } from '../models';
import { SurveyRecipientDto } from '../models';
import { SurveyResponseDetailDto } from '../models';
import { SurveyResponseDraftDto } from '../models';
import { SurveyResponseDto } from '../models';
import { SurveyResponseTableDto } from '../models';
import { SurveyTableDto } from '../models';
/**
 * SurveyApi - axios parameter creator
 * @export
 */
export const SurveyApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary Activates a survey by setting its start date to now
     * @param {string} survey_id Survey UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    surveyControllerActivateSurvey: async (
      survey_id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'survey_id' is not null or undefined
      if (survey_id === null || survey_id === undefined) {
        throw new RequiredError(
          'survey_id',
          'Required parameter survey_id was null or undefined when calling surveyControllerActivateSurvey.'
        );
      }
      const localVarPath = `/survey/{survey_id}/activate`.replace(
        `{${'survey_id'}}`,
        encodeURIComponent(String(survey_id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'PATCH',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Creates a new survey
     * @param {CreateSurveyDto} body
     * @param {string} [draft_id] Draft this survey is published from; deleted on success
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    surveyControllerCreateSurvey: async (
      body: CreateSurveyDto,
      draft_id?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling surveyControllerCreateSurvey.'
        );
      }
      const localVarPath = `/survey`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      if (draft_id !== undefined) {
        localVarQueryParameter['draft_id'] = draft_id;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof body !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(body !== undefined ? body : {})
        : body || '';

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Deactivates a survey by freezing its start date
     * @param {string} survey_id Survey UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    surveyControllerDeactivateSurvey: async (
      survey_id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'survey_id' is not null or undefined
      if (survey_id === null || survey_id === undefined) {
        throw new RequiredError(
          'survey_id',
          'Required parameter survey_id was null or undefined when calling surveyControllerDeactivateSurvey.'
        );
      }
      const localVarPath = `/survey/{survey_id}/deactivate`.replace(
        `{${'survey_id'}}`,
        encodeURIComponent(String(survey_id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'PATCH',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Deletes a survey and its subscribers
     * @param {string} id Survey UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    surveyControllerDeleteSurvey: async (
      id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      if (id === null || id === undefined) {
        throw new RequiredError(
          'id',
          'Required parameter id was null or undefined when calling surveyControllerDeleteSurvey.'
        );
      }
      const localVarPath = `/survey/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'DELETE',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Deletes a survey creation draft (owner only)
     * @param {string} draft_id Draft UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    surveyControllerDeleteSurveyCreationDraft: async (
      draft_id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'draft_id' is not null or undefined
      if (draft_id === null || draft_id === undefined) {
        throw new RequiredError(
          'draft_id',
          'Required parameter draft_id was null or undefined when calling surveyControllerDeleteSurveyCreationDraft.'
        );
      }
      const localVarPath = `/survey/drafts/{draft_id}`.replace(
        `{${'draft_id'}}`,
        encodeURIComponent(String(draft_id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'DELETE',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Retrieves all the created surveys
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    surveyControllerGetAllSurveys: async (
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/survey`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Retrieves the full detail of one of the authenticated user's responses
     * @param {string} response_id Response UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    surveyControllerGetMyResponseDetail: async (
      response_id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'response_id' is not null or undefined
      if (response_id === null || response_id === undefined) {
        throw new RequiredError(
          'response_id',
          'Required parameter response_id was null or undefined when calling surveyControllerGetMyResponseDetail.'
        );
      }
      const localVarPath = `/survey/responses/{response_id}`.replace(
        `{${'response_id'}}`,
        encodeURIComponent(String(response_id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Lists all responses submitted by the authenticated user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    surveyControllerGetMyResponses: async (
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/survey/responses`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Retrieves the pending surveys for user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    surveyControllerGetPendingSurveysForUser: async (
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/survey/pending`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Downloads a CSV with all answers for a survey
     * @param {string} survey_id Survey UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    surveyControllerGetSurveyAnswersCsv: async (
      survey_id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'survey_id' is not null or undefined
      if (survey_id === null || survey_id === undefined) {
        throw new RequiredError(
          'survey_id',
          'Required parameter survey_id was null or undefined when calling surveyControllerGetSurveyAnswersCsv.'
        );
      }
      const localVarPath = `/survey/{survey_id}/answers/csv`.replace(
        `{${'survey_id'}}`,
        encodeURIComponent(String(survey_id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Retrieves the content of a survey
     * @param {string} survey_id Survey UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    surveyControllerGetSurveyContent: async (
      survey_id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'survey_id' is not null or undefined
      if (survey_id === null || survey_id === undefined) {
        throw new RequiredError(
          'survey_id',
          'Required parameter survey_id was null or undefined when calling surveyControllerGetSurveyContent.'
        );
      }
      const localVarPath = `/survey/{survey_id}/content`.replace(
        `{${'survey_id'}}`,
        encodeURIComponent(String(survey_id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Retrieves the content of a survey creation draft (owner only)
     * @param {string} draft_id Draft UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    surveyControllerGetSurveyCreationDraft: async (
      draft_id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'draft_id' is not null or undefined
      if (draft_id === null || draft_id === undefined) {
        throw new RequiredError(
          'draft_id',
          'Required parameter draft_id was null or undefined when calling surveyControllerGetSurveyCreationDraft.'
        );
      }
      const localVarPath = `/survey/drafts/{draft_id}`.replace(
        `{${'draft_id'}}`,
        encodeURIComponent(String(draft_id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Lists the authenticated user's survey creation drafts
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    surveyControllerGetSurveyCreationDrafts: async (
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/survey/drafts`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Retrieves the full details of a survey
     * @param {string} survey_id Survey UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    surveyControllerGetSurveyDetails: async (
      survey_id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'survey_id' is not null or undefined
      if (survey_id === null || survey_id === undefined) {
        throw new RequiredError(
          'survey_id',
          'Required parameter survey_id was null or undefined when calling surveyControllerGetSurveyDetails.'
        );
      }
      const localVarPath = `/survey/{survey_id}/details`.replace(
        `{${'survey_id'}}`,
        encodeURIComponent(String(survey_id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Retrieves the authenticated user's draft answer for a survey, if any
     * @param {string} survey_id Survey UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    surveyControllerGetSurveyDraft: async (
      survey_id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'survey_id' is not null or undefined
      if (survey_id === null || survey_id === undefined) {
        throw new RequiredError(
          'survey_id',
          'Required parameter survey_id was null or undefined when calling surveyControllerGetSurveyDraft.'
        );
      }
      const localVarPath = `/survey/{survey_id}/answers/draft`.replace(
        `{${'survey_id'}}`,
        encodeURIComponent(String(survey_id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Retrieves the subscribed users of a survey
     * @param {string} survey_id Survey UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    surveyControllerGetSurveyRecipients: async (
      survey_id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'survey_id' is not null or undefined
      if (survey_id === null || survey_id === undefined) {
        throw new RequiredError(
          'survey_id',
          'Required parameter survey_id was null or undefined when calling surveyControllerGetSurveyRecipients.'
        );
      }
      const localVarPath = `/survey/{survey_id}/recipients`.replace(
        `{${'survey_id'}}`,
        encodeURIComponent(String(survey_id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'GET',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Registers a survey response for the authenticated user
     * @param {SurveyResponseDto} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    surveyControllerRespondToSurvey: async (
      body: SurveyResponseDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling surveyControllerRespondToSurvey.'
        );
      }
      const localVarPath = `/survey/respond`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof body !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(body !== undefined ? body : {})
        : body || '';

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Creates a survey creation draft
     * @param {SurveyCreationDraftDto} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    surveyControllerSaveNewSurveyCreationDraft: async (
      body: SurveyCreationDraftDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling surveyControllerSaveNewSurveyCreationDraft.'
        );
      }
      const localVarPath = `/survey/drafts`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof body !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(body !== undefined ? body : {})
        : body || '';

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Overwrites a survey creation draft
     * @param {SurveyCreationDraftDto} body
     * @param {string} draft_id Draft UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    surveyControllerSaveSurveyCreationDraft: async (
      body: SurveyCreationDraftDto,
      draft_id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling surveyControllerSaveSurveyCreationDraft.'
        );
      }
      // verify required parameter 'draft_id' is not null or undefined
      if (draft_id === null || draft_id === undefined) {
        throw new RequiredError(
          'draft_id',
          'Required parameter draft_id was null or undefined when calling surveyControllerSaveSurveyCreationDraft.'
        );
      }
      const localVarPath = `/survey/drafts/{draft_id}`.replace(
        `{${'draft_id'}}`,
        encodeURIComponent(String(draft_id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'PUT',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof body !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(body !== undefined ? body : {})
        : body || '';

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Saves or overwrites the authenticated user's draft answer for a survey
     * @param {SurveyResponseDraftDto} body
     * @param {string} survey_id Survey UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    surveyControllerSaveSurveyDraft: async (
      body: SurveyResponseDraftDto,
      survey_id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling surveyControllerSaveSurveyDraft.'
        );
      }
      // verify required parameter 'survey_id' is not null or undefined
      if (survey_id === null || survey_id === undefined) {
        throw new RequiredError(
          'survey_id',
          'Required parameter survey_id was null or undefined when calling surveyControllerSaveSurveyDraft.'
        );
      }
      const localVarPath = `/survey/{survey_id}/answers/draft`.replace(
        `{${'survey_id'}}`,
        encodeURIComponent(String(survey_id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'PUT',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof body !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(body !== undefined ? body : {})
        : body || '';

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Subscribes organizations to a survey
     * @param {SubscribeOrgsBody} body
     * @param {string} survey_id Survey UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    surveyControllerSubscribeOrgsToSurvey: async (
      body: SubscribeOrgsBody,
      survey_id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling surveyControllerSubscribeOrgsToSurvey.'
        );
      }
      // verify required parameter 'survey_id' is not null or undefined
      if (survey_id === null || survey_id === undefined) {
        throw new RequiredError(
          'survey_id',
          'Required parameter survey_id was null or undefined when calling surveyControllerSubscribeOrgsToSurvey.'
        );
      }
      const localVarPath = `/survey/{survey_id}/subscribe/orgs`.replace(
        `{${'survey_id'}}`,
        encodeURIComponent(String(survey_id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof body !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(body !== undefined ? body : {})
        : body || '';

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Subscribes users directly to a survey
     * @param {SubscribeUsersBody} body
     * @param {string} survey_id Survey UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    surveyControllerSubscribeUsersToSurvey: async (
      body: SubscribeUsersBody,
      survey_id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling surveyControllerSubscribeUsersToSurvey.'
        );
      }
      // verify required parameter 'survey_id' is not null or undefined
      if (survey_id === null || survey_id === undefined) {
        throw new RequiredError(
          'survey_id',
          'Required parameter survey_id was null or undefined when calling surveyControllerSubscribeUsersToSurvey.'
        );
      }
      const localVarPath = `/survey/{survey_id}/subscribe/users`.replace(
        `{${'survey_id'}}`,
        encodeURIComponent(String(survey_id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof body !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(body !== undefined ? body : {})
        : body || '';

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Unsubscribes organizations from a survey
     * @param {SubscribeOrgsBody1} body
     * @param {string} survey_id Survey UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    surveyControllerUnsubscribeOrgsFromSurvey: async (
      body: SubscribeOrgsBody1,
      survey_id: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling surveyControllerUnsubscribeOrgsFromSurvey.'
        );
      }
      // verify required parameter 'survey_id' is not null or undefined
      if (survey_id === null || survey_id === undefined) {
        throw new RequiredError(
          'survey_id',
          'Required parameter survey_id was null or undefined when calling surveyControllerUnsubscribeOrgsFromSurvey.'
        );
      }
      const localVarPath = `/survey/{survey_id}/subscribe/orgs`.replace(
        `{${'survey_id'}}`,
        encodeURIComponent(String(survey_id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'DELETE',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication JWT required
      // http bearer authentication required
      if (configuration && configuration.accessToken) {
        const accessToken =
          typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        localVarHeaderParameter['Authorization'] = 'Bearer ' + accessToken;
      }

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof body !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(body !== undefined ? body : {})
        : body || '';

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * SurveyApi - functional programming interface
 * @export
 */
export const SurveyApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Activates a survey by setting its start date to now
     * @param {string} survey_id Survey UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async surveyControllerActivateSurvey(
      survey_id: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await SurveyApiAxiosParamCreator(
        configuration
      ).surveyControllerActivateSurvey(survey_id, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Creates a new survey
     * @param {CreateSurveyDto} body
     * @param {string} [draft_id] Draft this survey is published from; deleted on success
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async surveyControllerCreateSurvey(
      body: CreateSurveyDto,
      draft_id?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<SurveyTableDto>>
    > {
      const localVarAxiosArgs = await SurveyApiAxiosParamCreator(
        configuration
      ).surveyControllerCreateSurvey(body, draft_id, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Deactivates a survey by freezing its start date
     * @param {string} survey_id Survey UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async surveyControllerDeactivateSurvey(
      survey_id: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await SurveyApiAxiosParamCreator(
        configuration
      ).surveyControllerDeactivateSurvey(survey_id, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Deletes a survey and its subscribers
     * @param {string} id Survey UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async surveyControllerDeleteSurvey(
      id: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await SurveyApiAxiosParamCreator(
        configuration
      ).surveyControllerDeleteSurvey(id, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Deletes a survey creation draft (owner only)
     * @param {string} draft_id Draft UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async surveyControllerDeleteSurveyCreationDraft(
      draft_id: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await SurveyApiAxiosParamCreator(
        configuration
      ).surveyControllerDeleteSurveyCreationDraft(draft_id, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Retrieves all the created surveys
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async surveyControllerGetAllSurveys(
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<Array<SurveyTableDto>>>
    > {
      const localVarAxiosArgs =
        await SurveyApiAxiosParamCreator(
          configuration
        ).surveyControllerGetAllSurveys(options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Retrieves the full detail of one of the authenticated user's responses
     * @param {string} response_id Response UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async surveyControllerGetMyResponseDetail(
      response_id: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<SurveyResponseDetailDto>>
    > {
      const localVarAxiosArgs = await SurveyApiAxiosParamCreator(
        configuration
      ).surveyControllerGetMyResponseDetail(response_id, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Lists all responses submitted by the authenticated user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async surveyControllerGetMyResponses(
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<Array<SurveyResponseTableDto>>>
    > {
      const localVarAxiosArgs =
        await SurveyApiAxiosParamCreator(
          configuration
        ).surveyControllerGetMyResponses(options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Retrieves the pending surveys for user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async surveyControllerGetPendingSurveysForUser(
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<Array<SurveyPendingTableDto>>>
    > {
      const localVarAxiosArgs =
        await SurveyApiAxiosParamCreator(
          configuration
        ).surveyControllerGetPendingSurveysForUser(options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Downloads a CSV with all answers for a survey
     * @param {string} survey_id Survey UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async surveyControllerGetSurveyAnswersCsv(
      survey_id: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await SurveyApiAxiosParamCreator(
        configuration
      ).surveyControllerGetSurveyAnswersCsv(survey_id, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Retrieves the content of a survey
     * @param {string} survey_id Survey UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async surveyControllerGetSurveyContent(
      survey_id: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<SurveyContentDto>>
    > {
      const localVarAxiosArgs = await SurveyApiAxiosParamCreator(
        configuration
      ).surveyControllerGetSurveyContent(survey_id, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Retrieves the content of a survey creation draft (owner only)
     * @param {string} draft_id Draft UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async surveyControllerGetSurveyCreationDraft(
      draft_id: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<SurveyCreationDraftDto>>
    > {
      const localVarAxiosArgs = await SurveyApiAxiosParamCreator(
        configuration
      ).surveyControllerGetSurveyCreationDraft(draft_id, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Lists the authenticated user's survey creation drafts
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async surveyControllerGetSurveyCreationDrafts(
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<Array<SurveyCreationDraftTableDto>>>
    > {
      const localVarAxiosArgs =
        await SurveyApiAxiosParamCreator(
          configuration
        ).surveyControllerGetSurveyCreationDrafts(options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Retrieves the full details of a survey
     * @param {string} survey_id Survey UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async surveyControllerGetSurveyDetails(
      survey_id: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<CreateSurveyDto>>
    > {
      const localVarAxiosArgs = await SurveyApiAxiosParamCreator(
        configuration
      ).surveyControllerGetSurveyDetails(survey_id, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Retrieves the authenticated user's draft answer for a survey, if any
     * @param {string} survey_id Survey UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async surveyControllerGetSurveyDraft(
      survey_id: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<SurveyResponseDraftDto>>
    > {
      const localVarAxiosArgs = await SurveyApiAxiosParamCreator(
        configuration
      ).surveyControllerGetSurveyDraft(survey_id, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Retrieves the subscribed users of a survey
     * @param {string} survey_id Survey UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async surveyControllerGetSurveyRecipients(
      survey_id: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<Array<SurveyRecipientDto>>>
    > {
      const localVarAxiosArgs = await SurveyApiAxiosParamCreator(
        configuration
      ).surveyControllerGetSurveyRecipients(survey_id, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Registers a survey response for the authenticated user
     * @param {SurveyResponseDto} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async surveyControllerRespondToSurvey(
      body: SurveyResponseDto,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await SurveyApiAxiosParamCreator(
        configuration
      ).surveyControllerRespondToSurvey(body, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Creates a survey creation draft
     * @param {SurveyCreationDraftDto} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async surveyControllerSaveNewSurveyCreationDraft(
      body: SurveyCreationDraftDto,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<SurveyCreationDraftTableDto>>
    > {
      const localVarAxiosArgs = await SurveyApiAxiosParamCreator(
        configuration
      ).surveyControllerSaveNewSurveyCreationDraft(body, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Overwrites a survey creation draft
     * @param {SurveyCreationDraftDto} body
     * @param {string} draft_id Draft UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async surveyControllerSaveSurveyCreationDraft(
      body: SurveyCreationDraftDto,
      draft_id: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<SurveyCreationDraftTableDto>>
    > {
      const localVarAxiosArgs = await SurveyApiAxiosParamCreator(
        configuration
      ).surveyControllerSaveSurveyCreationDraft(body, draft_id, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Saves or overwrites the authenticated user's draft answer for a survey
     * @param {SurveyResponseDraftDto} body
     * @param {string} survey_id Survey UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async surveyControllerSaveSurveyDraft(
      body: SurveyResponseDraftDto,
      survey_id: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await SurveyApiAxiosParamCreator(
        configuration
      ).surveyControllerSaveSurveyDraft(body, survey_id, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Subscribes organizations to a survey
     * @param {SubscribeOrgsBody} body
     * @param {string} survey_id Survey UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async surveyControllerSubscribeOrgsToSurvey(
      body: SubscribeOrgsBody,
      survey_id: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await SurveyApiAxiosParamCreator(
        configuration
      ).surveyControllerSubscribeOrgsToSurvey(body, survey_id, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Subscribes users directly to a survey
     * @param {SubscribeUsersBody} body
     * @param {string} survey_id Survey UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async surveyControllerSubscribeUsersToSurvey(
      body: SubscribeUsersBody,
      survey_id: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await SurveyApiAxiosParamCreator(
        configuration
      ).surveyControllerSubscribeUsersToSurvey(body, survey_id, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @summary Unsubscribes organizations from a survey
     * @param {SubscribeOrgsBody1} body
     * @param {string} survey_id Survey UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async surveyControllerUnsubscribeOrgsFromSurvey(
      body: SubscribeOrgsBody1,
      survey_id: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await SurveyApiAxiosParamCreator(
        configuration
      ).surveyControllerUnsubscribeOrgsFromSurvey(body, survey_id, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

/**
 * SurveyApi - factory interface
 * @export
 */
export const SurveyApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     *
     * @summary Activates a survey by setting its start date to now
     * @param {string} survey_id Survey UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async surveyControllerActivateSurvey(
      survey_id: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return SurveyApiFp(configuration)
        .surveyControllerActivateSurvey(survey_id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Creates a new survey
     * @param {CreateSurveyDto} body
     * @param {string} [draft_id] Draft this survey is published from; deleted on success
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async surveyControllerCreateSurvey(
      body: CreateSurveyDto,
      draft_id?: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<SurveyTableDto>> {
      return SurveyApiFp(configuration)
        .surveyControllerCreateSurvey(body, draft_id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Deactivates a survey by freezing its start date
     * @param {string} survey_id Survey UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async surveyControllerDeactivateSurvey(
      survey_id: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return SurveyApiFp(configuration)
        .surveyControllerDeactivateSurvey(survey_id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Deletes a survey and its subscribers
     * @param {string} id Survey UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async surveyControllerDeleteSurvey(
      id: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return SurveyApiFp(configuration)
        .surveyControllerDeleteSurvey(id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Deletes a survey creation draft (owner only)
     * @param {string} draft_id Draft UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async surveyControllerDeleteSurveyCreationDraft(
      draft_id: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return SurveyApiFp(configuration)
        .surveyControllerDeleteSurveyCreationDraft(draft_id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Retrieves all the created surveys
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async surveyControllerGetAllSurveys(
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<Array<SurveyTableDto>>> {
      return SurveyApiFp(configuration)
        .surveyControllerGetAllSurveys(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Retrieves the full detail of one of the authenticated user's responses
     * @param {string} response_id Response UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async surveyControllerGetMyResponseDetail(
      response_id: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<SurveyResponseDetailDto>> {
      return SurveyApiFp(configuration)
        .surveyControllerGetMyResponseDetail(response_id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Lists all responses submitted by the authenticated user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async surveyControllerGetMyResponses(
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<Array<SurveyResponseTableDto>>> {
      return SurveyApiFp(configuration)
        .surveyControllerGetMyResponses(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Retrieves the pending surveys for user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async surveyControllerGetPendingSurveysForUser(
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<Array<SurveyPendingTableDto>>> {
      return SurveyApiFp(configuration)
        .surveyControllerGetPendingSurveysForUser(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Downloads a CSV with all answers for a survey
     * @param {string} survey_id Survey UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async surveyControllerGetSurveyAnswersCsv(
      survey_id: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return SurveyApiFp(configuration)
        .surveyControllerGetSurveyAnswersCsv(survey_id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Retrieves the content of a survey
     * @param {string} survey_id Survey UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async surveyControllerGetSurveyContent(
      survey_id: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<SurveyContentDto>> {
      return SurveyApiFp(configuration)
        .surveyControllerGetSurveyContent(survey_id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Retrieves the content of a survey creation draft (owner only)
     * @param {string} draft_id Draft UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async surveyControllerGetSurveyCreationDraft(
      draft_id: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<SurveyCreationDraftDto>> {
      return SurveyApiFp(configuration)
        .surveyControllerGetSurveyCreationDraft(draft_id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Lists the authenticated user's survey creation drafts
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async surveyControllerGetSurveyCreationDrafts(
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<Array<SurveyCreationDraftTableDto>>> {
      return SurveyApiFp(configuration)
        .surveyControllerGetSurveyCreationDrafts(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Retrieves the full details of a survey
     * @param {string} survey_id Survey UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async surveyControllerGetSurveyDetails(
      survey_id: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<CreateSurveyDto>> {
      return SurveyApiFp(configuration)
        .surveyControllerGetSurveyDetails(survey_id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Retrieves the authenticated user's draft answer for a survey, if any
     * @param {string} survey_id Survey UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async surveyControllerGetSurveyDraft(
      survey_id: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<SurveyResponseDraftDto>> {
      return SurveyApiFp(configuration)
        .surveyControllerGetSurveyDraft(survey_id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Retrieves the subscribed users of a survey
     * @param {string} survey_id Survey UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async surveyControllerGetSurveyRecipients(
      survey_id: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<Array<SurveyRecipientDto>>> {
      return SurveyApiFp(configuration)
        .surveyControllerGetSurveyRecipients(survey_id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Registers a survey response for the authenticated user
     * @param {SurveyResponseDto} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async surveyControllerRespondToSurvey(
      body: SurveyResponseDto,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return SurveyApiFp(configuration)
        .surveyControllerRespondToSurvey(body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Creates a survey creation draft
     * @param {SurveyCreationDraftDto} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async surveyControllerSaveNewSurveyCreationDraft(
      body: SurveyCreationDraftDto,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<SurveyCreationDraftTableDto>> {
      return SurveyApiFp(configuration)
        .surveyControllerSaveNewSurveyCreationDraft(body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Overwrites a survey creation draft
     * @param {SurveyCreationDraftDto} body
     * @param {string} draft_id Draft UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async surveyControllerSaveSurveyCreationDraft(
      body: SurveyCreationDraftDto,
      draft_id: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<SurveyCreationDraftTableDto>> {
      return SurveyApiFp(configuration)
        .surveyControllerSaveSurveyCreationDraft(body, draft_id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Saves or overwrites the authenticated user's draft answer for a survey
     * @param {SurveyResponseDraftDto} body
     * @param {string} survey_id Survey UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async surveyControllerSaveSurveyDraft(
      body: SurveyResponseDraftDto,
      survey_id: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return SurveyApiFp(configuration)
        .surveyControllerSaveSurveyDraft(body, survey_id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Subscribes organizations to a survey
     * @param {SubscribeOrgsBody} body
     * @param {string} survey_id Survey UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async surveyControllerSubscribeOrgsToSurvey(
      body: SubscribeOrgsBody,
      survey_id: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return SurveyApiFp(configuration)
        .surveyControllerSubscribeOrgsToSurvey(body, survey_id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Subscribes users directly to a survey
     * @param {SubscribeUsersBody} body
     * @param {string} survey_id Survey UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async surveyControllerSubscribeUsersToSurvey(
      body: SubscribeUsersBody,
      survey_id: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return SurveyApiFp(configuration)
        .surveyControllerSubscribeUsersToSurvey(body, survey_id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Unsubscribes organizations from a survey
     * @param {SubscribeOrgsBody1} body
     * @param {string} survey_id Survey UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async surveyControllerUnsubscribeOrgsFromSurvey(
      body: SubscribeOrgsBody1,
      survey_id: string,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return SurveyApiFp(configuration)
        .surveyControllerUnsubscribeOrgsFromSurvey(body, survey_id, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * SurveyApi - object-oriented interface
 * @export
 * @class SurveyApi
 * @extends {BaseAPI}
 */
export class SurveyApi extends BaseAPI {
  /**
   *
   * @summary Activates a survey by setting its start date to now
   * @param {string} survey_id Survey UUID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SurveyApi
   */
  public async surveyControllerActivateSurvey(
    survey_id: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return SurveyApiFp(this.configuration)
      .surveyControllerActivateSurvey(survey_id, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Creates a new survey
   * @param {CreateSurveyDto} body
   * @param {string} [draft_id] Draft this survey is published from; deleted on success
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SurveyApi
   */
  public async surveyControllerCreateSurvey(
    body: CreateSurveyDto,
    draft_id?: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<SurveyTableDto>> {
    return SurveyApiFp(this.configuration)
      .surveyControllerCreateSurvey(body, draft_id, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Deactivates a survey by freezing its start date
   * @param {string} survey_id Survey UUID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SurveyApi
   */
  public async surveyControllerDeactivateSurvey(
    survey_id: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return SurveyApiFp(this.configuration)
      .surveyControllerDeactivateSurvey(survey_id, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Deletes a survey and its subscribers
   * @param {string} id Survey UUID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SurveyApi
   */
  public async surveyControllerDeleteSurvey(
    id: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return SurveyApiFp(this.configuration)
      .surveyControllerDeleteSurvey(id, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Deletes a survey creation draft (owner only)
   * @param {string} draft_id Draft UUID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SurveyApi
   */
  public async surveyControllerDeleteSurveyCreationDraft(
    draft_id: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return SurveyApiFp(this.configuration)
      .surveyControllerDeleteSurveyCreationDraft(draft_id, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Retrieves all the created surveys
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SurveyApi
   */
  public async surveyControllerGetAllSurveys(
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<Array<SurveyTableDto>>> {
    return SurveyApiFp(this.configuration)
      .surveyControllerGetAllSurveys(options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Retrieves the full detail of one of the authenticated user's responses
   * @param {string} response_id Response UUID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SurveyApi
   */
  public async surveyControllerGetMyResponseDetail(
    response_id: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<SurveyResponseDetailDto>> {
    return SurveyApiFp(this.configuration)
      .surveyControllerGetMyResponseDetail(response_id, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Lists all responses submitted by the authenticated user
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SurveyApi
   */
  public async surveyControllerGetMyResponses(
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<Array<SurveyResponseTableDto>>> {
    return SurveyApiFp(this.configuration)
      .surveyControllerGetMyResponses(options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Retrieves the pending surveys for user
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SurveyApi
   */
  public async surveyControllerGetPendingSurveysForUser(
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<Array<SurveyPendingTableDto>>> {
    return SurveyApiFp(this.configuration)
      .surveyControllerGetPendingSurveysForUser(options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Downloads a CSV with all answers for a survey
   * @param {string} survey_id Survey UUID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SurveyApi
   */
  public async surveyControllerGetSurveyAnswersCsv(
    survey_id: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return SurveyApiFp(this.configuration)
      .surveyControllerGetSurveyAnswersCsv(survey_id, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Retrieves the content of a survey
   * @param {string} survey_id Survey UUID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SurveyApi
   */
  public async surveyControllerGetSurveyContent(
    survey_id: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<SurveyContentDto>> {
    return SurveyApiFp(this.configuration)
      .surveyControllerGetSurveyContent(survey_id, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Retrieves the content of a survey creation draft (owner only)
   * @param {string} draft_id Draft UUID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SurveyApi
   */
  public async surveyControllerGetSurveyCreationDraft(
    draft_id: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<SurveyCreationDraftDto>> {
    return SurveyApiFp(this.configuration)
      .surveyControllerGetSurveyCreationDraft(draft_id, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Lists the authenticated user's survey creation drafts
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SurveyApi
   */
  public async surveyControllerGetSurveyCreationDrafts(
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<Array<SurveyCreationDraftTableDto>>> {
    return SurveyApiFp(this.configuration)
      .surveyControllerGetSurveyCreationDrafts(options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Retrieves the full details of a survey
   * @param {string} survey_id Survey UUID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SurveyApi
   */
  public async surveyControllerGetSurveyDetails(
    survey_id: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<CreateSurveyDto>> {
    return SurveyApiFp(this.configuration)
      .surveyControllerGetSurveyDetails(survey_id, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Retrieves the authenticated user's draft answer for a survey, if any
   * @param {string} survey_id Survey UUID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SurveyApi
   */
  public async surveyControllerGetSurveyDraft(
    survey_id: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<SurveyResponseDraftDto>> {
    return SurveyApiFp(this.configuration)
      .surveyControllerGetSurveyDraft(survey_id, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Retrieves the subscribed users of a survey
   * @param {string} survey_id Survey UUID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SurveyApi
   */
  public async surveyControllerGetSurveyRecipients(
    survey_id: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<Array<SurveyRecipientDto>>> {
    return SurveyApiFp(this.configuration)
      .surveyControllerGetSurveyRecipients(survey_id, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Registers a survey response for the authenticated user
   * @param {SurveyResponseDto} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SurveyApi
   */
  public async surveyControllerRespondToSurvey(
    body: SurveyResponseDto,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return SurveyApiFp(this.configuration)
      .surveyControllerRespondToSurvey(body, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Creates a survey creation draft
   * @param {SurveyCreationDraftDto} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SurveyApi
   */
  public async surveyControllerSaveNewSurveyCreationDraft(
    body: SurveyCreationDraftDto,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<SurveyCreationDraftTableDto>> {
    return SurveyApiFp(this.configuration)
      .surveyControllerSaveNewSurveyCreationDraft(body, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Overwrites a survey creation draft
   * @param {SurveyCreationDraftDto} body
   * @param {string} draft_id Draft UUID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SurveyApi
   */
  public async surveyControllerSaveSurveyCreationDraft(
    body: SurveyCreationDraftDto,
    draft_id: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<SurveyCreationDraftTableDto>> {
    return SurveyApiFp(this.configuration)
      .surveyControllerSaveSurveyCreationDraft(body, draft_id, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Saves or overwrites the authenticated user's draft answer for a survey
   * @param {SurveyResponseDraftDto} body
   * @param {string} survey_id Survey UUID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SurveyApi
   */
  public async surveyControllerSaveSurveyDraft(
    body: SurveyResponseDraftDto,
    survey_id: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return SurveyApiFp(this.configuration)
      .surveyControllerSaveSurveyDraft(body, survey_id, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Subscribes organizations to a survey
   * @param {SubscribeOrgsBody} body
   * @param {string} survey_id Survey UUID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SurveyApi
   */
  public async surveyControllerSubscribeOrgsToSurvey(
    body: SubscribeOrgsBody,
    survey_id: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return SurveyApiFp(this.configuration)
      .surveyControllerSubscribeOrgsToSurvey(body, survey_id, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Subscribes users directly to a survey
   * @param {SubscribeUsersBody} body
   * @param {string} survey_id Survey UUID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SurveyApi
   */
  public async surveyControllerSubscribeUsersToSurvey(
    body: SubscribeUsersBody,
    survey_id: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return SurveyApiFp(this.configuration)
      .surveyControllerSubscribeUsersToSurvey(body, survey_id, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @summary Unsubscribes organizations from a survey
   * @param {SubscribeOrgsBody1} body
   * @param {string} survey_id Survey UUID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SurveyApi
   */
  public async surveyControllerUnsubscribeOrgsFromSurvey(
    body: SubscribeOrgsBody1,
    survey_id: string,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return SurveyApiFp(this.configuration)
      .surveyControllerUnsubscribeOrgsFromSurvey(body, survey_id, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
